/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import DispositionListsDetailsPanel from './layout';


export default connect(/*mapStateToProps*/)(DispositionListsDetailsPanel);
